import React from 'react';
import TabBar from '@/shared/components/navigation/TabBar';
import { Tabs } from 'expo-router';
import MobileHeader from '@/shared/components/navigation/MobileHeader';
import { useUserEvents } from '@/shared/hooks/useUserEvents';
import { useSavePushToken } from '@/shared/hooks/useSavePushToken';
import { useSaveUserTimeZone } from '@/shared/hooks/useSaveUserTimeZone';
import { useTrackUserActivity } from '@/shared/hooks/useTrackUserActivity';

export default function RootLayout() {
  useUserEvents();
  useSavePushToken();
  useSaveUserTimeZone();
  useTrackUserActivity();

  return (
    <Tabs
      screenOptions={{
        header: () => <MobileHeader />,
      }}
      // Keep custom TabBar due to difficulty hiding tab buttons
      // for specific routes through native tab props
      tabBar={() => <TabBar />}
    />
  );
}
